import { render, staticRenderFns } from "./ControlTab.vue?vue&type=template&id=6b28ce3a&scoped=true"
import script from "./ControlTab.vue?vue&type=script&lang=ts"
export * from "./ControlTab.vue?vue&type=script&lang=ts"
import style0 from "./ControlTab.vue?vue&type=style&index=0&id=6b28ce3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28ce3a",
  null
  
)

export default component.exports